import { ProductImagesUploader } from './ProductImagesUploader.main';

export { ProductImagesUploader };
